export default __webpack_public_path__ + "static/media/gpbleibtbunt.5dfb1fdc.png";